// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--UYjxl","inner":"inner--_INLC","heading":"heading--nggTy","text":"text--tAMER","fadeSlideUp":"fadeSlideUp--DaSGZ"};